import { TagType } from '@myre/common-tag';

import { Pipe, type PipeTransform } from '@angular/core';

import { type SubTheme } from '../types/theme-type';

@Pipe({ name: 'subThemeToTagType' })
export class SubThemeToTagTypePipe implements PipeTransform {
  public transform(subTheme: SubTheme): number {
    switch (subTheme) {
      case 'primary': {
        return TagType.Primary;
      }
      case 'secondary': {
        return TagType.Secondary;
      }
      case 'tertiary': {
        return TagType.Tertiary;
      }
      case 'quinary':
      case 'default':
      default: {
        return TagType.Quinary;
      }
    }
  }
}
